/**
 * 新建/编辑任务模块
 * editAssignmentModule
 * author: Qian.qianchen 2019-05-09
 */
"use strict";
angular.module('editAssignmentModule', ['editAssignmentServiceModule'])
    .controller('editAssignmentCtrl', ['$scope', 'trsHttpService', 'editAssignmentService', '$stateParams', '$q', 'trsspliceString', '$validation', 'modalDialog', '$filter', 'taskAssignmentService', 'planningCenterService', function($scope, trsHttpService, editAssignmentService, $stateParams, $q, trsspliceString, $validation, modalDialog, $filter, taskAssignmentService, planningCenterService) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                assignmentId: angular.isDefined($stateParams.assignmentid) ? $stateParams.assignmentid : 0,
                platform: angular.isDefined($stateParams.platform) ? $stateParams.platform : 0,
                isTrial: angular.isDefined($stateParams.istrial) && $stateParams.istrial == 1 ? true : false,
            };
            $scope.data = {
                executorArr: [],
            };
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            if ($scope.status.assignmentId != 0) {
                initEditData();
            } else {
                initNewData();
            }
        }
        /**
         * [initNeData description] 新建数据初始化
         * @return {[type]} [description]
         */
        function initNewData() {
            $scope.list = editAssignmentService.initAssignmentData($scope.status.platform);
        }
        /**
         * [initEditData description] 编辑数据初始化
         * @return {[type]} [description]
         */
        function initEditData() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_taskcommand',
                methodname: 'getTaskDetail',
                TaskId: $scope.status.assignmentId
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "GET").then(function(data) {
                $scope.list = {
                    "TaskCommandId": $scope.status.assignmentId,
                    "TaskName": data.TASKNAME,
                    "TaskTime": data.TASKTIME,
                    "TaskAddress": angular.isDefined(data.TASKADDRESS) ? data.TASKADDRESS : "",
                    "Content": data.CONTENT,
                    "UserIds": data.USERIDS,
                    "Remarks": data.REMARKS,
                    "Address": data.ADDRESS,
                    "IsMine": $scope.status.platform
                };
                let userIdArr = data.USERIDS.split(',');
                let userNameArr = data.USERNAMES.split(',');
                $scope.data.myStatus = data.MYSTATUS;
                $scope.data.executorArr = userIdArr.map(function(item, index) {
                    return {
                        USERNAME: userNameArr[index],
                        ID: item
                    };
                });
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [sendToTrial description] 送审
         * @return {[type]} [description]
         */
        function sendToTrial() {
            let defer = $q.defer();
            let params = {
                serviceid: 'mlf_taskcommand',
                methodname: 'submitTask',
                TaskIds: $scope.status.assignmentId
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                modalDialog.alertType('送审成功', '', 'success', false, function() {
                    history.go(-1);
                });
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [setLocation description] 地图定位
         */
        $scope.setLocation = function() {
            planningCenterService.setLocation($scope.list.TaskAddress).then(function(address) {
                $scope.list.TaskAddress = address;
            });
        };
        /**
         * [addExecutor description] 添加执行人
         */
        $scope.addExecutor = function() {
            $scope.editorJson = $scope.data.executorArr;
            editAssignmentService.addExecutor($scope).then(function(result) {
                $scope.data.executorArr = result.map(function(item) {
                    return {
                        ID: item.ID,
                        USERNAME: item.USERNAME
                    };
                });
            });
        };
        /**
         * [deleteItem description] 删除执行人
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.deleteItem = function(item) {
            $scope.data.executorArr.splice($scope.data.executorArr.indexOf(item), 1);
        }
        /**
         * [confirm description] 审核并发布
         * @return {[type]} [description]
         */
        $scope.confirm = function(flag) {
            var defer = $q.defer();
            flag = angular.isDefined(flag) ? flag : true;
            $scope.assignmentForm.$pending = {};
            $validation.validate($scope.assignmentForm)
                .success(function() {
                    var list = angular.copy($scope.list);
                    list.UserIds = trsspliceString.spliceString($scope.data.executorArr, 'ID', ',');
                    list.serviceid = 'mlf_taskcommand';
                    list.methodname = 'saveTaskCommand';
                    list.TaskTime = $filter("date")(list.TaskTime, "yyyy-MM-dd HH:mm:ss");
                    list.TaskAddress = list.TaskAddress == "" ? "" : JSON.stringify(list.TaskAddress);
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, "POST").then(function(data) {
                        if (flag) {
                            modalDialog.alertType($scope.status.assignmentId != 0 ? '编辑成功' : '创建成功', '', 'success', false, function() {
                                history.go(-1);
                            });
                        }
                        $scope.status.assignmentId = data.TASKCOMMANDID;
                        defer.resolve();
                    });
                });
            return defer.promise;
        }
        /**
         *  审核
         * @return {[type]} [description]
         */
        $scope.trial = function() {
            var params = {
                serviceid: "mlf_taskcommand",
                methodname: "checkTask",
                TaskIds: $scope.status.assignmentId
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                modalDialog.alertType('审核成功', '', 'success', false, function() {
                    history.go(-1);
                });
            });
        }
        /**
         * [reject description]驳回
         * @return {[type]} [description]
         */
        $scope.reject = function() {
            taskAssignmentService.assignmentReject($scope.status.assignmentId).then(function() {
                history.go(-1);
            });
        }
        /**
         * [goBack description] 返回
         * @return {[type]} [description]
         */
        $scope.goBack = function() {
            history.go(-1);
        }
        /**
         * [trialPermission description] 送审按钮显示/隐藏
         * @return {[type]} [description]
         */
        $scope.trialPermission = function() {
            return (angular.isDefined($scope.data.myStatus) && ($scope.data.myStatus == 0 || $scope.data.myStatus == -1 || $scope.data.myStatus == 1) || angular.isUndefined($scope.data.myStatus)) && (!$scope.status.isTrial) && $scope.status.platform == 1;
        }
        /**
         * [sendToTrial description] 送审
         * @return {[type]} [description]
         */
        $scope.sendToTrial = function() {
            $scope.confirm(false).then(function() {
                sendToTrial();
            });
        }
    }]);